export const CHANGE_EVENT_PREFERENCES = {
	CHANGE_EVENTS_DAILY: 'Change Events Delivered, Last 24 hours',
	CHANGE_EVENTS_MONTHLY: 'Change Events Delivered, Monthly',
	DISABLED_TEXT: 'Integration Blueprint & Data Security is Disabled. Click \'Refresh Objects\' to Re-enabled.',
	DISABLE_CONFIRM_LINE1: 'Disabling Object Monitoring will remove the objects from the custom channel.',
	DISABLE_CONFIRM_LINE2:
		// eslint-disable-next-line max-len
		'You must disable Object Monitoring in order to make changes which objects you have selected in Salesforce.  After updating the objects in Salesforce click Refresh Objects in Arovy to reenable Object Monitoring.',
	DISABLE_CONFIRM_LINE3: 'Are you sure you want to disable Object Monitoring?',
	MANAGE_OBJECTS: 'Manage Objects In Salesforce',
	MANAGE_OBJECTS_CONFIRM_LINE1:
		// eslint-disable-next-line max-len
		'Continuing will disable Object Monitoring and remove the objects from the custom channel.  After updating the selection of objects in Salesforce, click Refresh Objects in Arovy to reenable Object Monitoring.',
	MANAGE_OBJECTS_CONFIRM_LINE2:
		// eslint-disable-next-line max-len
		'Are you sure you want to disable Object Monitoring?',
	NO_OBJECTS_SELECTED: 'No objects selected to generatate change event notifications.',
	OBJECTS_ALREADY_SELECTED: 'Objects already selected',
	OBJECTS_MONITORED: (count: number): string => `Objects Monitored (${count})`,
	OUT_OF: (count: number): string => `(of ${count.toLocaleString('en')})`,
	READ_HELP_ARTICLE: 'Read Help Article',
	REAUTHENTICATE: 'Reauthenticate',
	REFRESH_OBJECTS: 'Refresh Objects',
	SALESFORCE_CREDENTIALS_EXPIRED: 'Your Salesforce Credentials have expired.  Please reauthenticate.',
	SELECTED_LIMITS:
		// eslint-disable-next-line max-len
		'The following objects are set to generate change event notifications. Click the Edit Objects button to change your selected objects in Salesforce.',
	SELECTED_OBJECTS: 'Selected Objects',
	SELECT_SUGGESTED_OBJECTS_ERROR:
		// eslint-disable-next-line max-len
		'You\'ve already made object selections in Salesforce.  To use the Arovy suggested Objects, remove all objects in Salesforce and then refresh the page.',
	TOOLTIP_DAILY:
		// eslint-disable-next-line max-len
		'This is the number of Change Events Delivered to Arovy for any create, edit, or delete action on the monitored objects below with the last rolling 24 hours. For more information on Change Event limits refer to <a href="https://developer.salesforce.com/docs/atlas.en-us.change_data_capture.meta/change_data_capture/cdc_allocations.htm?q=limit">this document</a>.',
	TOOLTIP_MONTHLY:
		// eslint-disable-next-line max-len
		'This is the number of Change Events Delivered to Arovy for any create, edit, or delete action on the monitored objects below for this current month. For more information on Change Event limits refer to <a href="https://developer.salesforce.com/docs/atlas.en-us.change_data_capture.meta/change_data_capture/cdc_allocations.htm?q=limit">this document</a>.',
	USE_SUGGESTED_OBJECTS: 'Use Arovy Suggested Objects'
};
